module.exports = __webpack_public_path__ + "69aa2d6297a7e5baabd27b8b023da0ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/15_CC_V_Balloon.png
// module id = 116
// module chunks = 0